module.exports = "/assets/data/a93ef8ed9e0076278fb34e951267196c-SY4.data.json";